import React from 'react';

import TasksPage from '../components/TasksPage';

const TasksApp = (props) => (
  <TasksPage {...props} />
);

export default TasksApp;
